var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync"},[_c('div',{staticClass:"sync__syncing"},[_vm._v("СИНХРОНИЗАЦИЯ")]),_c('div',{staticClass:"sync__progress"},[_c('div',{staticClass:"sync__progress__cached",style:({ width: _vm.cachedWidth })})])])}
var staticRenderFns = []

export { render, staticRenderFns }